<section class="error">
  <div class="error__inner">
      <h1>401</h1>
      <h2>{{'error.label.401' | translate}}</h2>
      <p>{{'error.label.401.desc' | translate}}</p>

      <button class="btn btn-primary" (click)="goBack()"> {{ 'generic.label.go.back' | translate}} </button>

  </div>
</section>
